import * as React from 'react';
import ArticleCollectionView from '@reverbdotcom/commons/dist/components/article_collection_view';

interface Props {
  articles: any[];
  heading: string;
  action?: JSX.Element;
}

export default function RelatedArticles(props: Props) {
  if (props.articles.length < 2) { return null; }

  return (
    <ArticleCollectionView
      title={props.heading}
      articles={props.articles}
      action={props.action}
    />
  );
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/shared/related_articles.tsx